import { API, graphqlOperation } from "aws-amplify";
import { getChannelPaymentMethods } from "./graphql/client-queries";
import { captureError } from "./utilities";

export function getPaymentMethods(env) {
  if (env === "master" || env === "master2") {
    return [
      {
        name: "Nordea",
        selected_value: "nordea",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/nordea.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Osuuspankki",
        selected_value: "osuuspankki",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/osuuspankki.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Handelsbanken",
        selected_value: "handelsbanken",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/handelsbanken.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Danske Bank",
        selected_value: "danskebank",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/danskebank.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Paikallisosuuspankki",
        selected_value: "paikallisosuuspankki",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/paikallisosuuspankki.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Säästöpankki",
        selected_value: "saastopankki",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/saastopankki.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Aktia",
        selected_value: "aktia",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/aktia.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Ålandsbanken",
        selected_value: "alandsbanken",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/alandsbanken.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "S-Pankki",
        selected_value: "spankki",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/spankki.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Oma Säästöpankki",
        selected_value: "omasaastopankki",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/omasaastopankki.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Nordea B2B",
        selected_value: "nordeab2b",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/nordeab2b.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Danske Bank B2B",
        selected_value: "danskebankb2b",
        group: "banks",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/danskebankb2b.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "Visa",
        selected_value: "creditcards",
        group: "creditcards",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/visa.png",
        img_timestamp: 1727158396,
        currency: [
          "AED",
          "AFN",
          "ALL",
          "AMD",
          "ANG",
          "ARS",
          "AUD",
          "AWG",
          "AZN",
          "BAM",
          "BBD",
          "BDT",
          "BGN",
          "BMD",
          "BND",
          "BOB",
          "BRL",
          "BSD",
          "BWP",
          "BZD",
          "CAD",
          "CDF",
          "CHF",
          "CNY",
          "COP",
          "CRC",
          "CUP",
          "CVE",
          "CZK",
          "DKK",
          "DOP",
          "DZD",
          "EGP",
          "ERN",
          "ETB",
          "EUR",
          "FJD",
          "GBP",
          "GEL",
          "GHS",
          "GIP",
          "GMD",
          "GTQ",
          "GYD",
          "HKD",
          "HNL",
          "HRK",
          "HTG",
          "HUF",
          "IDR",
          "ILS",
          "INR",
          "IRR",
          "JMD",
          "KES",
          "KHR",
          "KZT",
          "LAK",
          "LBP",
          "LKR",
          "LRD",
          "MAD",
          "MDL",
          "MGA",
          "MKD",
          "MNT",
          "MOP",
          "MRO",
          "MUR",
          "MVR",
          "MWK",
          "MXN",
          "MYR",
          "MZN",
          "NAD",
          "NGN",
          "NIO",
          "NOK",
          "NPR",
          "NZD",
          "PAB",
          "PEN",
          "PGK",
          "PHP",
          "PKR",
          "PLN",
          "QAR",
          "RON",
          "RSD",
          "RUB",
          "SAR",
          "SBD",
          "SCR",
          "SEK",
          "SGD",
          "SLL",
          "SOS",
          "STD",
          "SVC",
          "SZL",
          "THB",
          "TOP",
          "TRY",
          "TTD",
          "TWD",
          "TZS",
          "UAH",
          "USD",
          "UYU",
          "UZS",
          "WST",
          "XCD",
          "YER",
          "ZAR",
          "ZMW",
        ],
      },
      {
        name: "Mastercard",
        selected_value: "creditcards",
        group: "creditcards",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/mastercard.png",
        img_timestamp: 1727158396,
        currency: [
          "AED",
          "AFN",
          "ALL",
          "AMD",
          "ANG",
          "ARS",
          "AUD",
          "AWG",
          "AZN",
          "BAM",
          "BBD",
          "BDT",
          "BGN",
          "BMD",
          "BND",
          "BOB",
          "BRL",
          "BSD",
          "BWP",
          "BZD",
          "CAD",
          "CDF",
          "CHF",
          "CNY",
          "COP",
          "CRC",
          "CUP",
          "CVE",
          "CZK",
          "DKK",
          "DOP",
          "DZD",
          "EGP",
          "ERN",
          "ETB",
          "EUR",
          "FJD",
          "GBP",
          "GEL",
          "GHS",
          "GIP",
          "GMD",
          "GTQ",
          "GYD",
          "HKD",
          "HNL",
          "HRK",
          "HTG",
          "HUF",
          "IDR",
          "ILS",
          "INR",
          "IRR",
          "JMD",
          "KES",
          "KHR",
          "KZT",
          "LAK",
          "LBP",
          "LKR",
          "LRD",
          "MAD",
          "MDL",
          "MGA",
          "MKD",
          "MNT",
          "MOP",
          "MRO",
          "MUR",
          "MVR",
          "MWK",
          "MXN",
          "MYR",
          "MZN",
          "NAD",
          "NGN",
          "NIO",
          "NOK",
          "NPR",
          "NZD",
          "PAB",
          "PEN",
          "PGK",
          "PHP",
          "PKR",
          "PLN",
          "QAR",
          "RON",
          "RSD",
          "RUB",
          "SAR",
          "SBD",
          "SCR",
          "SEK",
          "SGD",
          "SLL",
          "SOS",
          "STD",
          "SVC",
          "SZL",
          "THB",
          "TOP",
          "TRY",
          "TTD",
          "TWD",
          "TZS",
          "UAH",
          "USD",
          "UYU",
          "UZS",
          "WST",
          "XCD",
          "YER",
          "ZAR",
          "ZMW",
        ],
      },
      {
        name: "Google Pay",
        selected_value: "googlepay",
        group: "wallets",
        min_amount: 1,
        max_amount: 2000000,
        img: "https://www.vismapay.com/e-payments/method_logos/googlepay.png",
        img_timestamp: 1762334186,
        currency: [
          "AED",
          "AFN",
          "ALL",
          "AMD",
          "ARS",
          "AUD",
          "AWG",
          "AZN",
          "BAM",
          "BBD",
          "BDT",
          "BGN",
          "BMD",
          "BND",
          "BOB",
          "BRL",
          "BSD",
          "BWP",
          "BZD",
          "CAD",
          "CDF",
          "CHF",
          "CNY",
          "COP",
          "CRC",
          "CUP",
          "CVE",
          "CZK",
          "DKK",
          "DOP",
          "DZD",
          "EGP",
          "ERN",
          "ETB",
          "EUR",
          "FJD",
          "GBP",
          "GEL",
          "GHS",
          "GIP",
          "GMD",
          "GTQ",
          "GYD",
          "HKD",
          "HNL",
          "HRK",
          "HTG",
          "HUF",
          "IDR",
          "ILS",
          "INR",
          "IRR",
          "JMD",
          "KES",
          "KHR",
          "KZT",
          "LAK",
          "LBP",
          "LKR",
          "LRD",
          "MAD",
          "MDL",
          "MGA",
          "MKD",
          "MNT",
          "MOP",
          "MRO",
          "MUR",
          "MVR",
          "MWK",
          "MXN",
          "MYR",
          "MZN",
          "NAD",
          "NGN",
          "NIO",
          "NOK",
          "NPR",
          "NZD",
          "PAB",
          "PEN",
          "PGK",
          "PHP",
          "PKR",
          "PLN",
          "QAR",
          "RON",
          "RSD",
          "RUB",
          "SAR",
          "SBD",
          "SCR",
          "SEK",
          "SGD",
          "SLL",
          "SOS",
          "STD",
          "SVC",
          "SZL",
          "THB",
          "TOP",
          "TRY",
          "TTD",
          "TWD",
          "TZS",
          "UAH",
          "USD",
          "UYU",
          "UZS",
          "WST",
          "XCD",
          "YER",
          "ZAR",
          "ZMW",
        ],
      },
      {
        name: "Apple Pay",
        selected_value: "applepay",
        group: "wallets",
        min_amount: 1,
        max_amount: 2000000,
        img: "https://www.vismapay.com/e-payments/method_logos/applepay.png",
        img_timestamp: 1762334186,
        currency: [
          "AED",
          "AFN",
          "ALL",
          "AMD",
          "ARS",
          "AUD",
          "AWG",
          "AZN",
          "BAM",
          "BBD",
          "BDT",
          "BGN",
          "BMD",
          "BND",
          "BOB",
          "BRL",
          "BSD",
          "BWP",
          "BZD",
          "CAD",
          "CDF",
          "CHF",
          "CNY",
          "COP",
          "CRC",
          "CUP",
          "CVE",
          "CZK",
          "DKK",
          "DOP",
          "DZD",
          "EGP",
          "ERN",
          "ETB",
          "EUR",
          "FJD",
          "GBP",
          "GEL",
          "GHS",
          "GIP",
          "GMD",
          "GTQ",
          "GYD",
          "HKD",
          "HNL",
          "HRK",
          "HTG",
          "HUF",
          "IDR",
          "ILS",
          "INR",
          "IRR",
          "JMD",
          "KES",
          "KHR",
          "KZT",
          "LAK",
          "LBP",
          "LKR",
          "LRD",
          "MAD",
          "MDL",
          "MGA",
          "MKD",
          "MNT",
          "MOP",
          "MRO",
          "MUR",
          "MVR",
          "MWK",
          "MXN",
          "MYR",
          "MZN",
          "NAD",
          "NGN",
          "NIO",
          "NOK",
          "NPR",
          "NZD",
          "PAB",
          "PEN",
          "PGK",
          "PHP",
          "PKR",
          "PLN",
          "QAR",
          "RON",
          "RSD",
          "RUB",
          "SAR",
          "SBD",
          "SCR",
          "SEK",
          "SGD",
          "SLL",
          "SOS",
          "STD",
          "SVC",
          "SZL",
          "THB",
          "TOP",
          "TRY",
          "TTD",
          "TWD",
          "TZS",
          "UAH",
          "USD",
          "UYU",
          "UZS",
          "WST",
          "XCD",
          "YER",
          "ZAR",
          "ZMW",
        ],
      },
      {
        name: "Mobilepay",
        selected_value: "mobilepay",
        group: "wallets",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/mobilepay.png",
        img_timestamp: 1727158396,
        currency: ["EUR", "DKK", "SEK", "NOK"],
      },
      {
        name: "Siirto",
        selected_value: "siirto",
        group: "wallets",
        min_amount: 1,
        max_amount: 600000,
        img: "https://www.vismapay.com/e-payments/method_logos/siirto.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
      {
        name: "OP Lasku",
        selected_value: "oplasku",
        group: "creditinvoices",
        min_amount: 1,
        max_amount: 500000,
        img: "https://www.vismapay.com/e-payments/method_logos/oplasku.png",
        img_timestamp: 1727158396,
        currency: ["EUR"],
      },
    ];
  } else {
    return [
      {
        name: "Nordea",
        selected_value: "nordea",
        group: "banks",
        min_amount: 1,
        max_amount: 20000000,
        img: "https://www.vismapay.com/e-payments/method_logos/nordea.png",
        img_timestamp: 1629195202,
        currency: ["EUR"],
      },
      {
        name: "Osuuspankki",
        selected_value: "osuuspankki",
        group: "banks",
        min_amount: 1,
        max_amount: 20000000,
        img: "https://www.vismapay.com/e-payments/method_logos/osuuspankki.png",
        img_timestamp: 1629195202,
        currency: ["EUR"],
      },
      {
        name: "Visa",
        selected_value: "creditcards",
        group: "creditcards",
        min_amount: 1,
        max_amount: 20000000,
        img: "https://www.vismapay.com/e-payments/method_logos/visa.png",
        img_timestamp: 1629195202,
        currency: [
          "AED",
          "AFN",
          "ALL",
          "AMD",
          "ANG",
          "ARS",
          "AUD",
          "AWG",
          "AZN",
          "BAM",
          "BBD",
          "BDT",
          "BGN",
          "BMD",
          "BND",
          "BOB",
          "BRL",
          "BSD",
          "BWP",
          "BZD",
          "CAD",
          "CDF",
          "CHF",
          "CNY",
          "COP",
          "CRC",
          "CUP",
          "CVE",
          "CZK",
          "DKK",
          "DOP",
          "DZD",
          "EGP",
          "ERN",
          "ETB",
          "EUR",
          "FJD",
          "GBP",
          "GEL",
          "GHS",
          "GIP",
          "GMD",
          "GTQ",
          "GYD",
          "HKD",
          "HNL",
          "HRK",
          "HTG",
          "HUF",
          "IDR",
          "ILS",
          "INR",
          "IRR",
          "ISK",
          "JMD",
          "KES",
          "KHR",
          "KZT",
          "LAK",
          "LBP",
          "LKR",
          "LRD",
          "MAD",
          "MDL",
          "MGA",
          "MKD",
          "MNT",
          "MOP",
          "MRO",
          "MUR",
          "MVR",
          "MWK",
          "MXN",
          "MYR",
          "MZN",
          "NAD",
          "NGN",
          "NIO",
          "NOK",
          "NPR",
          "NZD",
          "PAB",
          "PEN",
          "PGK",
          "PHP",
          "PKR",
          "PLN",
          "QAR",
          "RON",
          "RSD",
          "RUB",
          "SAR",
          "SBD",
          "SCR",
          "SEK",
          "SGD",
          "SLL",
          "SOS",
          "STD",
          "SVC",
          "SZL",
          "THB",
          "TOP",
          "TRY",
          "TTD",
          "TWD",
          "TZS",
          "UAH",
          "USD",
          "UYU",
          "UZS",
          "WST",
          "XCD",
          "YER",
          "ZAR",
          "ZMW",
        ],
      },
      {
        name: "Mastercard",
        selected_value: "creditcards",
        group: "creditcards",
        min_amount: 1,
        max_amount: 20000000,
        img: "https://www.vismapay.com/e-payments/method_logos/mastercard.png",
        img_timestamp: 1629195202,
        currency: [
          "AED",
          "AFN",
          "ALL",
          "AMD",
          "ANG",
          "ARS",
          "AUD",
          "AWG",
          "AZN",
          "BAM",
          "BBD",
          "BDT",
          "BGN",
          "BMD",
          "BND",
          "BOB",
          "BRL",
          "BSD",
          "BWP",
          "BZD",
          "CAD",
          "CDF",
          "CHF",
          "CNY",
          "COP",
          "CRC",
          "CUP",
          "CVE",
          "CZK",
          "DKK",
          "DOP",
          "DZD",
          "EGP",
          "ERN",
          "ETB",
          "EUR",
          "FJD",
          "GBP",
          "GEL",
          "GHS",
          "GIP",
          "GMD",
          "GTQ",
          "GYD",
          "HKD",
          "HNL",
          "HRK",
          "HTG",
          "HUF",
          "IDR",
          "ILS",
          "INR",
          "IRR",
          "ISK",
          "JMD",
          "KES",
          "KHR",
          "KZT",
          "LAK",
          "LBP",
          "LKR",
          "LRD",
          "MAD",
          "MDL",
          "MGA",
          "MKD",
          "MNT",
          "MOP",
          "MRO",
          "MUR",
          "MVR",
          "MWK",
          "MXN",
          "MYR",
          "MZN",
          "NAD",
          "NGN",
          "NIO",
          "NOK",
          "NPR",
          "NZD",
          "PAB",
          "PEN",
          "PGK",
          "PHP",
          "PKR",
          "PLN",
          "QAR",
          "RON",
          "RSD",
          "RUB",
          "SAR",
          "SBD",
          "SCR",
          "SEK",
          "SGD",
          "SLL",
          "SOS",
          "STD",
          "SVC",
          "SZL",
          "THB",
          "TOP",
          "TRY",
          "TTD",
          "TWD",
          "TZS",
          "UAH",
          "USD",
          "UYU",
          "UZS",
          "WST",
          "XCD",
          "YER",
          "ZAR",
          "ZMW",
        ],
      },
    ];
  }

  return [];
}

export async function loadPaymentMethods({ env, companyId, currency = "EUR" }) {
  if (!companyId) {
    return getPaymentMethods(env);
  }

  try {
    const response = await API.graphql(
      graphqlOperation(getChannelPaymentMethods, {
        companyId,
        currency,
      })
    );
    const paymentMethods = response?.data?.getChannelPaymentMethods;
    if (Array.isArray(paymentMethods) && paymentMethods.length > 0) {
      return paymentMethods;
    }
  } catch (e) {
    captureError(
      "Loading channel payment methods failed",
      "GET_CHANNEL_PAYMENT_METHODS_FAILED",
      e
    );
  }

  return getPaymentMethods(env);
}
